import {
  customElement,
  DeesElement,
  property,
  html,
  cssManager,
  unsafeCSS,
  css,
  TemplateResult,
} from '@design.estate/dees-element';

@customElement('philkunz-actionbar')
export class PhilkunzActionbar extends DeesElement {
  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        min-height: 48px;
        font-family: 'Geist Sans';
        background: ${cssManager.bdTheme('#eeeeeb', '#000000')};
      }
      :host([hidden]) {
        display: none;
      }

      .maincontainer {
        padding: 24px;
        color: ${cssManager.bdTheme('#333', '#fff')};
        position: relative;
        max-width: 1200px;
        overflow: hidden;
        margin: auto;
        line-height: 48px;
        
      }

      .teaser {
        text-align: center;
        font-family: 'Cal Sans';
        font-size: 24px;
        margin-bottom: 16px;
      }

      .flexContainer {
        justify-content: center;
        display: flex;
        flex-direction: row;
      }

      ${cssManager.cssForPhablet(css`
        .flexContainer {
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 16px;
        }
      `)}

      a {
        height: 1.75em;
        line-height: 1.75em;
        display: block;
        text-decoration: none;
        color: ${cssManager.bdTheme('#333', '#ccc')};
        padding: 0px 0.5em;
        margin: 0px 2px;
        border-radius: 4px;
        margin-top: 0px;
      }

      a:hover {
        color: ${cssManager.bdTheme('#000', '#fff')};
        background: ${cssManager.bdTheme('#ccc', '#333333')};
      }

      .separator {
        height: 24px;
        width: 4px;
        border-radius: 10px;
        line-height: 48px;
        display: block;
        margin-right: 16px;
        margin-left: 16px;
        background: ${cssManager.bdTheme('#ccc', '#222')};
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <style></style>
      <div class="maincontainer">
        <div class="teaser">Want to know more about me?</div>
        <div class="flexContainer">
          <a href="https://www.linkedin.com/in/philkunzcom/">LinkedIn</a>
          <a href="https://twitter.com/philkunzcom">Twitter</a>
          <a href="https://www.instagram.com/philkunz/">Instagram</a>
          <a href="https://www.facebook.com/philkunzcom">Facebook</a>
          <div class="separator"></div>
          <a href="https://task.vc">Task Venture Capital</a>
          <div class="separator"></div>
          <a href="https://cv.philkunz.com">CV</a>
        </div>
      </div>
    `;
  }
}
